import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { Logo } from '../components/Logo';
import { ApiError, apiFetch } from '../lib/api';

const Schema = z.object({ email: z.string().email().toLowerCase() });

export const LoginPage = () => {
  const nav = useNavigate();
  const [emailError, setEmailError] = useState<string | undefined>();

  const mutation = useMutation({
    mutationFn: async (email: string) =>
      apiFetch<{ status: string }>('/auth/sign-in/magic-link', {
        method: 'POST',
        body: { email, callbackURL: `${window.location.origin}/` },
      }),
    onSuccess: (_, email) => {
      nav('/verify', { state: { email } });
    },
  });

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setEmailError(undefined);
    const fd = new FormData(e.currentTarget);
    const parsed = Schema.safeParse({ email: String(fd.get('email') ?? '') });
    if (!parsed.success) {
      setEmailError(parsed.error.issues[0]?.message);
      return;
    }
    mutation.mutate(parsed.data.email);
  };

  const apiErr = mutation.error instanceof ApiError ? mutation.error : null;

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Logo className="text-center mb-6" />
        <form onSubmit={onSubmit} className="card space-y-4">
          <div>
            <h2 className="text-xl font-semibold mb-1">entrar</h2>
            <p className="text-sm text-navy-500">você vai receber um link mágico no email.</p>
          </div>

          {apiErr && (
            <div className="bg-red-50 border border-red-200 rounded p-3 text-sm text-red-700">
              <strong>{apiErr.code}:</strong> {apiErr.message}
            </div>
          )}

          <div>
            <label className="label" htmlFor="email">
              email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="input"
              required
              autoComplete="email"
            />
            {emailError && <p className="error">{emailError}</p>}
          </div>

          <div className="flex items-center justify-between pt-2">
            <Link to="/signup" className="text-sm text-navy-600 hover:text-navy-800 underline">
              criar conta
            </Link>
            <button type="submit" className="btn-primary" disabled={mutation.isPending}>
              {mutation.isPending ? 'enviando...' : 'enviar link'}
            </button>
          </div>
        </form>
        <p className="text-center text-xs text-navy-500 mt-6">by lions intelligence</p>
      </div>
    </div>
  );
};
